import { useState } from "react";
import { getDocsSectionConfig, getDocsVersionMeta } from "@/config/docs-config";
import DocsPageLayout from "@/layouts/docs-page-layout";
import DocsPageBanner from "@/components/docs/docs-page-banner";
import DocsEndpointCard from "@/components/docs/docs-endpoint-card";

const DocsMeetingsSummaryPage = () => {
  const [version, setVersion] = useState("beta");
  const section = getDocsSectionConfig("meets_summary", version);
  const meta = getDocsVersionMeta(version);
  const endpoints = section?.endpoints ?? [];

  return (
    <DocsPageLayout>
      <div className="flex flex-col gap-6">
        <DocsPageBanner
          title="Meetings Summaries API"
          description={section?.description}
          meta={meta}
          version={version}
          onVersionChange={setVersion}
        />

        <div className="flex flex-col gap-4">
          {endpoints.length > 0 ? (
            endpoints.map((endpoint) => <DocsEndpointCard endpoint={endpoint} key={endpoint.id} />)
          ) : (
            <p className="text-glass-foreground-muted text-sm">
              No endpoints documented for this version yet.
            </p>
          )}
        </div>
      </div>
    </DocsPageLayout>
  );
};

export default DocsMeetingsSummaryPage;